export const KUNCI_SIMPANAN_REFERRAL = "pdk-ref"
